/**
 * paty-shipping-bar.js — barra «Te faltan X € para el envío GRATIS».
 * Escucha StandardEvents.cartLinesUpdate en document (el mismo evento con el que el
 * cart drawer del core se entera de los cambios). El evento es optimista: si trae una
 * promesa (event.promise, ver core cart-drawer.js), esperamos a que se resuelva antes
 * de pedir /cart.js para leer el total autoritativo. Sin polling. CSP-safe: solo
 * textContent/createElement.
 */
import { StandardEvents } from '@shopify/events';

const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

class PatyShippingBar extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold, 10) || 3900;
    try {
      this.money = new Intl.NumberFormat('es-ES', { style: 'currency', currency: this.dataset.currency || 'EUR' });
    } catch {
      this.money = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
    }
    this._onCart = (e) => {
      const p = e && e.promise;
      if (p && typeof p.then === 'function') p.then(() => this.refresh(), () => {});
      else this.refresh();
    };
    document.addEventListener(StandardEvents.cartLinesUpdate, this._onCart);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this._onCart);
  }

  async refresh() {
    const seq = (this._seq = (this._seq || 0) + 1);
    try {
      const cart = await fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (seq !== this._seq) return;
      this.render(Number(cart.total_price) || 0);
    } catch {
      /* red caída: conservamos el último estado pintado */
    }
  }

  render(total) {
    const remaining = this.threshold - total;
    const pct = Math.max(0, Math.min(100, Math.round((total / this.threshold) * 100)));
    const fill = this.querySelector('[data-shipbar-fill]');
    const track = this.querySelector('[data-shipbar-track]');
    const msg = this.querySelector('[data-shipbar-msg]');
    if (fill) fill.style.width = pct + '%';
    if (track) track.setAttribute('aria-valuenow', String(pct));
    this.classList.toggle('paty-shipbar--done', remaining <= 0);
    if (!msg) return;
    msg.textContent = '';
    if (remaining > 0) {
      msg.append(document.createTextNode((this.dataset.tPrefix || '') + ' '));
      const strong = document.createElement('strong');
      strong.textContent = this.money.format(remaining / 100);
      msg.append(strong, document.createTextNode(' ' + (this.dataset.tSuffix || '')));
    } else {
      msg.textContent = '🎉 ' + (this.dataset.tDone || '');
    }
  }
}

if (!customElements.get('paty-shipping-bar')) {
  customElements.define('paty-shipping-bar', PatyShippingBar);
}
